import { render, staticRenderFns } from "./add-form.vue?vue&type=template&id=42ddd5e5&"
import script from "./add-form.vue?vue&type=script&lang=js&"
export * from "./add-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports